import React, { useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { AuthLogin } from "../../features/auth/Slice";
import Cookies from "js-cookie";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [err, setErr] = useState(false);
  const [message, setMessage] = useState("");

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const onSubmit = async (data) => {
    try {
      setErr(false);
      setMessage("");

      const result = await dispatch(AuthLogin(data));

      const response = result.payload;

      if (response?.success === true) {
        const token = response?.data?.token;

        if (token) {
          Cookies.set("super_admin_security", token, {
            expires: 365,
            path: "/",
          });

          navigate("/student/detail");
        }

        return;
      }

      // Email error
      if (response?.errors?.email) {
        setError("email", {
          type: "server",
          message: response.errors.email,
        });
      }

      // Password error
      if (response?.errors?.password) {
        setError("password", {
          type: "server",
          message: response.errors.password,
        });
      }

      setErr(true);
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <section className="Login">
      <div className="container-fluid p-0">
        <div className="login-card">
          <div className="text-holder-login">
            <div className="logo_div">
              <img
                src="/assets/images/logo/logo.png"
                className="logo_img"
                alt="Logo"
              />
            </div>

            <h2 className="text-start heading_text">Login as Admin</h2>

            <p className="text-start mt-4">
              Admin access unlocked, let’s get started!
            </p>

            {err && message && <span style={errorStyle}>{message}</span>}

            <Form onSubmit={handleSubmit(onSubmit)}>
              {/* Email */}
              <Form.Group className="mb-3 form-control-email" controlId="email">
                <Form.Label className="email_txt">Email ID</Form.Label>

                <Form.Control
                  type="email"
                  className="inputForm"
                  placeholder="Enter Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                />

                {errors.email && (
                  <Form.Text className="text-danger">
                    {errors.email.message}
                  </Form.Text>
                )}
              </Form.Group>

              {/* Password */}
              <Form.Group
                className="mb-3 form-control-email password_section"
                controlId="password"
              >
                <Form.Label className="email_txt">Password</Form.Label>

                <div className="input-group">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    className="inputForm"
                    placeholder="Password"
                    {...register("password", {
                      required: "Password is required",
                    })}
                  />

                  <FontAwesomeIcon
                    icon={showPassword ? faEye : faEyeSlash}
                    className="formPasword"
                    onClick={togglePasswordVisibility}
                  />
                </div>

                {errors.password && (
                  <Form.Text className="text-danger">
                    {errors.password.message}
                  </Form.Text>
                )}
              </Form.Group>

              <input className="form-control dummy_input" placeholder="dummy" />

              <Button type="submit" className="btn sign-in-button text-center">
                Login
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
